import tmsApi from '../api/tmsApi';
// import helper from './helper';

// const { createInputParam } = helper;

export default {
  namespaced: true,
  state: {
    dataState: {
      issue: 'LOADING',
    },
    issues: [],
    detailData: null,
    detailDataId: null,
    dataLoaded: false,
    count_info: {
      all: 0,
    },
    query: {
      search: '',
      company_id: null,
      page: {
        lastData: null,
        count: 2,
      },
      sort: {
        by: 'CREATED_AT',
        direction: 'ASC',
      },
    },
    errors: {
      actions: [],
    },
  },
  mutations: {
    CLEAR_DATA(state) {
      state.issues.splice(0);
    },
    ADD_DATA_ON_LIST(state, data) {
      state.issues.push(data);
    },
    CLEAR_QUERY({ query }) {
      query.page.lastData = null;
      query.search = '';
      query.page.count = 2;
      query.sort.by = 'CREATED_AT';
      query.sort.direction = 'ASC';
    },
    SET_COMPANY_ID(state, id) {
      state.query.company_id = id;
    },
    SET_QUERY_SEARCH(state, search) {
      state.query.search = search;
    },
    SET_QUERY_PAGE(state, number) {
      state.query.page.number = number;
    },
    SET_QUERY_COUNT(state, count) {
      state.query.page.count = count;
    },
    SET_QUERY_SORT(state, sort) {
      const [by, direction] = sort.split('.');
      state.query.sort.direction = direction;
      state.query.sort.by = by;
    },
    SET_COUNT_INFO(state, info) {
      state.count_info.all = 0;
      info.forEach((c) => {
        state.count_info.all += c.count;
      }, this);
    },
    SET_DETAIL_ID(state, id) {
      state.detailDataId = id;
    },
    SET_DETAIL_DATA(state, data) {
      state.detailData = data;
    },
    SET_QUERY_LAST_DATA({ query }, data) {
      query.page.lastData = data;
    },
    DELETE_DETAIL_DATA(state, id) {
      const index = state.issues.findIndex(issue => issue.id === id);
      state.issues.splice(index, 1);
    },
    ADD_ERROR(state, action) {
      state.errors.actions.push(action);
    },
    REMOVE_ERROR(state, error) {
      const index = state.errors.actions.findIndex(err => err === error);
      state.errors.actions.splice(index, 1);
    },
    SET_DATA_LOADED(state) {
      state.dataLoaded = true;
    },
    SET_DATA_NOT_LOADED(state) {
      state.dataLoaded = false;
    },
    SET_DATA_ISSUE({ dataState }, state) {
      dataState.issue = state;
    },
  },
  getters: {
    issues(state) {
      return state.issues;
    },
    companies(state) {
      return state.issues;
    },
    count_all(state) {
      return state.count_info.all;
    },
    query_count(state) {
      return state.query.page.count;
    },
    query_page(state) {
      return state.query.page.number;
    },
    get_detail_data(state) {
      return state.detailData || {};
    },
    dataLoaded(state) {
      return state.dataLoaded;
    },
    loadIssue(state) {
      return state.dataState.issue;
    },
  },
  actions: {
    LOAD_DATA({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const { count, lastData } = state.query.page;
      const { by, direction } = state.query.sort;
      const limit = count;
      let after = '';
      let before = '';

      if (direction === 'ASC') {
        after = `after: "${lastData}"`;
      } else {
        before = `before: "${lastData}"`;
      }
      let skip = '';
      if (lastData !== null) {
        skip = `
          skip: {
            by: ID
            ${after}
            ${before}
          },
        `;
      }
      const query = `
      {
        issues (
          limit: ${limit},
          sort: {
            by: ${by},
            direction: ${direction}
          },
          ${skip}
        )
        {
          id
          title
          status
          metadata
          description
          driver {
            id
            name
          }
          vehicle {
            id
            reg_no
            company {
              id
              name
            }
          }
          created_at
        }
      }
      `;
      commit('CLEAR_DATA');
      commit('SET_DATA_NOT_LOADED');
      commit('SET_DATA_ISSUE', 'LOADING');
      return api(query, 'issues').then(({ data }) => {
        const { issues } = data;
        issues.forEach((issue) => {
          commit('ADD_DATA_ON_LIST', issue);
        }, this);
        commit('SET_DATA_LOADED');
        commit('SET_DATA_ISSUE', 'LOADED');
      }).catch(() => {
        commit('SET_DATA_ISSUE', 'ERROR');
      });
    },
    LOAD_DETAIL_DATA({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const query = `
        {
          issue(id: ${state.detailDataId}) {
            id
            title
            status
            metadata
            issue_type
            description
            driver {
              id
              name
            }
            vehicle {
              id
              reg_no
              company {
                id
                name
              }
            }
            created_at
          }
        }
      `;
      return api(query, 'issue').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.issue);
        return data.issue;
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_DETAIL_DATA');
      });
    },
    FIND_DATA({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const { count } = state.query.page;
      const { by, direction } = state.query.sort;
      const limit = count;
      const query = `
        {
          issues: find_issues(
            query: "${state.query.search}",
            limit: ${limit},
            sort: {
              by: ${by},
              direction: ${direction}
            },
          )
          {
            id
            title
            status
            metadata
            description
            driver {
              id
              name
            }
            vehicle {
              id
              reg_no
              company {
                id
                name
              }
            }
            created_at
          }
        }
      `;
      commit('CLEAR_DATA');
      commit('SET_DATA_NOT_LOADED');
      commit('SET_DATA_ISSUE', 'LOADING');
      return api(query, 'issues').then(({ data }) => {
        const { issues } = data;
        issues.forEach((issue) => {
          commit('ADD_DATA_ON_LIST', issue);
        }, this);
        commit('SET_DATA_LOADED');
        commit('SET_DATA_ISSUE', 'LOADED');
      }).catch(() => {
        commit('SET_DATA_ISSUE', 'ERROR');
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/issues.js